<template>
  <div>
    <banner choose-int="1951172444214992897"></banner>
    <bread :jup-path="'/' + pagePath" :jup-page="pageTitle"></bread>
    <div class="product">
      <div class="con w1440">
        <div
          class="wow fadeInUp slow animated"
          style="visibility: visible; animation-name: fadeInUp"
        >
          <div class="text">
            <div id="fix" v-html="aboutUs.content"></div>
          </div>
        </div>
      </div>
    </div>
    <customFooter></customFooter>
  </div>
</template>

<script>
import customFooter from "@/components/footer/footer";
import Bread from "@/components/bread/Bread";
import Banner from "@/components/banner/Banner";
import { getArticleById } from "@/api/article";
export default {
  name: "WeldedPipe",
  components: {
    customFooter,
    Bread,
    Banner,
  },
  data() {
    return {
      pagePath: "weldedpipe",
      pageTitle: "钢友钢管",
      aboutUs: {},
    };
  },
  created() {
    getArticleById("1676418119193436162").then((res) => {
      this.aboutUs = res.data.data;
    });
  },
};
</script>

<style scoped></style>
